'use client'

import { PusherIdleCloseSetup } from '@b-stock/fe-core/bstock-next/components'
import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'

/** A flag value that is not a number (a string, null, missing) counts as 0, off. */
export const toDelayMinutes = (value: unknown): number =>
  typeof value === 'number' ? value : 0

/**
 * Closes idle Pusher sockets in a tab hidden longer than the
 * `pusher-hidden-disconnect-minutes` flag. Render once per router, inside
 * `FeatureFlagProvider` and fe-core's AuthProvider. fe-core treats 0, negative
 * and NaN as off.
 */
export function PusherIdleClose() {
  const delayMinutes = toDelayMinutes(
    useFlag(FeatureFlags.PUSHER_HIDDEN_DISCONNECT_MINUTES)
  )
  return <PusherIdleCloseSetup delayMinutes={delayMinutes} />
}
